import { useTranslation } from 'react-i18next';
import type { TransactionStatus } from '@hero/schema';
import { Badge } from '../../../ui/Badge/Badge';
import { getTransactionStatusBadgeClass } from '@hero/web-theme';
import { TransactionStatusDynamicIcon } from '@hero/web-icons';

export interface TransactionStatusBadgeProps {
  status: TransactionStatus;
  showIcon?: boolean;
}

export function TransactionStatusBadge({ status, showIcon = true }: TransactionStatusBadgeProps) {
  const { t } = useTranslation('m-payment');

  const style = getTransactionStatusBadgeClass(status);
  const label = t(`transaction.status.${status}`);

  return (
    <Badge
      variant="secondary"
      size="default"
      className={style}
      icon={showIcon ? <TransactionStatusDynamicIcon status={status} /> : undefined}>
      {label}
    </Badge>
  );
}
